import CryptoJS from 'crypto-js/crypto-js';

// 默认值
// const iv = CryptoJS.enc.Utf8.parse('deg;LKJU1234++=-'); // ''中与后台一样  偏移量
const key = CryptoJS.enc.Utf8.parse('deg;LKJU1234++=-'); // ''中与后台一样  密码
const mode = CryptoJS.mode.ECB;
const padding = CryptoJS.pad.Pkcs7;

/**
 * AES加密 ：字符串 key iv  返回base64
 */
export function encrypt(word, config = {}) {
    const encrypted = CryptoJS.AES.encrypt(word, config.key || key, getOption(config));
    return encrypted.ciphertext.toString();
}

/**
 * AES 解密 ：字符串 key iv  返回base64
 *  */
export function decrypt(word, config = {}) {
    const decrypt = CryptoJS.AES.decrypt(word, config.key || key, getOption(config));
    return decrypt.toString(CryptoJS.enc.Utf8).toString();
}

/**
 * 处理config
 *  */
function getOption(config = {}) {
    const option = {
        mode: config.mode || mode,
        padding: config.padding || padding
    };
    if (config.iv) {
        option.iv = config.iv;
    }
    return option;
}
